'use client'

import { CSSProperties, HTMLProps } from 'react'
import clsx from 'classnames'
import styles from './tag-link.module.scss'

interface TagLinkProps extends HTMLProps<HTMLAnchorElement> {
  name: string
  color?: string
}

export const TagLink = (props: TagLinkProps) => {
  const { className, href, name, color, style = {}, ...restProps } = props
  const extendStyle = color
    ? ({ '--indicator-color': color.startsWith('#') ? color : `var(--${color})` } as CSSProperties)
    : {}
  return (
    <a
      className={clsx(styles.container, 'text text_type_t2', className)}
      target="_blank"
      href={href}
      style={{ ...style, ...extendStyle }}
      {...restProps}
    >
      {name}
    </a>
  )
}
